import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { MessageModal } from '../../components/modals/MessageModal';
export function VerifyOTPPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [resendTimer, setResendTimer] = useState(60);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: '',
    message: '',
    type: 'info' as 'success' | 'error' | 'info'
  });
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);
  const handleOtpChange = (index: number, value: string) => {
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const otpValue = otp.join('');
    if (otpValue.length !== 6) {
      setModalContent({
        title: 'Invalid OTP',
        message: 'Please enter all 6 digits.',
        type: 'error'
      });
      setIsMessageModalOpen(true);
      return;
    }
    setModalContent({
      title: 'Verification Successful',
      message: 'Your email has been verified. Redirecting to dashboard...',
      type: 'success'
    });
    setIsMessageModalOpen(true);
    setTimeout(() => {
      navigate('/dashboard');
    }, 2000);
  };
  const handleResendOTP = () => {
    setModalContent({
      title: 'OTP Sent',
      message: 'A new OTP has been sent to your email address.',
      type: 'success'
    });
    setIsMessageModalOpen(true);
    setResendTimer(60);
    setOtp(['', '', '', '', '', '']);
  };
  const handleResendEmail = () => {
    setModalContent({
      title: 'Verification Email Sent',
      message: 'A new verification email has been sent. Please check your inbox and spam folder.',
      type: 'success'
    });
    setIsMessageModalOpen(true);
  };
  return <div data-testid="verify-otp-page" className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933]" data-id="element-2346">
      <header data-testid="verify-otp-header" className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-2347">
        <Link data-testid="verify-otp-logo-link" to="/" className="flex items-center gap-2" data-id="element-2348">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-2349"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-2350">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main data-testid="verify-otp-main" className="max-w-md mx-auto px-4 py-12" data-id="element-2351">
        <div data-testid="verify-otp-card" className="bg-white border border-gray-300 p-8 shadow-sm" data-id="element-2352">
          <h1 data-testid="verify-otp-title" className="text-2xl font-bold mb-2" data-id="element-2353">
            Verify Your Email
          </h1>
          <p data-testid="verify-otp-subtitle" className="text-sm text-gray-500 mb-6" data-id="element-2354">
            We've sent a 6-digit code to{' '}
            <span className="font-bold" data-id="element-2355">{email}</span>
          </p>

          <form data-testid="verify-otp-form" onSubmit={handleSubmit} className="space-y-6" data-id="element-2356">
            <div data-testid="verify-otp-inputs" className="flex gap-2 justify-center" data-id="element-2357">
              {otp.map((digit, index) => <input key={index} id={`otp-${index}`} data-testid={`verify-otp-input-${index + 1}`} type="text" maxLength={1} value={digit} onChange={e => handleOtpChange(index, e.target.value)} className="w-12 h-12 text-center text-xl font-bold border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-2358" />)}
            </div>

            <button data-testid="verify-otp-submit-btn" type="submit" className="w-full py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-2359">
              Verify Email
            </button>
          </form>

          <div data-testid="verify-otp-resend-section" className="mt-6 space-y-3" data-id="element-2360">
            <div className="text-center" data-id="element-2361">
              {resendTimer > 0 ? <p data-testid="verify-otp-timer" className="text-xs text-gray-500" data-id="element-2362">
                  Resend OTP in{' '}
                  <span className="font-bold" data-id="element-2363">{resendTimer}s</span>
                </p> : <button data-testid="verify-otp-resend-btn" onClick={handleResendOTP} className="text-xs text-blue-600 font-bold hover:underline" data-id="element-2364">
                  Resend OTP
                </button>}
            </div>

            <div className="text-center" data-id="element-2365">
              <button data-testid="verify-otp-resend-email-btn" onClick={handleResendEmail} className="text-xs text-blue-600 font-bold hover:underline" data-id="element-2366">
                Resend Verification Email
              </button>
            </div>
          </div>

          <p data-testid="verify-otp-back-link" className="mt-6 text-center text-sm text-gray-600" data-id="element-2367">
            Wrong email?{' '}
            <Link to="/auth/signup" className="text-blue-600 font-bold hover:underline" data-id="element-2368">
              Go Back
            </Link>
          </p>
        </div>
      </main>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title={modalContent.title} message={modalContent.message} type={modalContent.type} data-id="element-2369" />
    </div>;
}